<template>
  <div>
    <!-- <p>手机版用户中心</p> -->
    <div class="header flex-row">
      <!-- <img @click="back" class="backImg" src="@/assets/images/mobile/return.png" alt=""> -->
      <div class="headCon flex-row">
        <div class="imgCon flex-row flex-center">
          <img
            src="@/assets/images/mobile/user_2.png"
            style="width: 3.5rem"
            alt=""
          />
        </div>
        <div style="padding-right: 5px">
          <p style="color: #fff; margin-bottom: 10px">
            {{ userInfo.enterpriseInfo.enterprise }}
          </p>
          <img src="@/assets/images/mobile/rz_user.png" style="width: 1.5rem;" alt="" />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="mainCon flex-row flex-evenly">
        <div
          @click="toRelevantPage(item.url)"
          class="mainConItem flex-column flex-center"
          v-for="(item, index) in mainConData"
          :key="index"
        >
          <img :src="item.icon" alt="" />
          <p>{{ item.title }}</p>
        </div>
      </div>
      <div class="listCon" v-if="showFlag == 'listCon'">
        <ul>
          <li
            class="listConItem flex-row flex-start"
            v-for="(item, index) in listConData"
            :key="index"
            @click="tonewpage(index)"
          >
            <img :src="item.icon" alt="" />
            <p>{{ item.title }}</p>
            <div class="num">{{ item.num }}</div>
            <img
              class="arrow"
              src="@/assets/images/mobile/arrow_right.png"
              alt=""
            />
          </li>
        </ul>
      </div>
      <div class="phoneBind" v-if="showFlag == 'phoneBind'">
        <img
          class="closePhoneBind"
          @click="closePhoneBindPage"
          src="@/assets/images/mobile/close.png"
          alt=""
        />
        <p>手机绑定</p>
        <div class="formCon">
          <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="" prop="oldPhone">
              <el-input
                placeholder="请输入企业法人原手机号"
                v-model="form.oldPhone"
                prefix-icon="el-icon-phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="newPhone">
              <el-input
                placeholder="请输入企业法人新手机号"
                v-model="form.newPhone"
                prefix-icon="el-icon-phone"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                style="width: 48%; margin-right: 2%"
                prefix-icon="el-icon-user"
                placeholder="验证码"
                v-model="form.verifyCode"
              ></el-input>
              <el-button
                class="mailCode"
                @click="getVerCode"
                v-if="!(hasFlag || hastime > 0)"
                v-html="'获取短信验证码'"
              >
              </el-button>
              <el-button
                style="width: 50%"
                @click="getVerCode"
                v-else
                :disabled="true"
                v-html="`${hastime}秒后再获取`"
              >
              </el-button>
            </el-form-item>
            <el-form-item label="">
              <el-button style="width: 100%" type="primary" @click="onSubmit"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="backBtnCon" v-if="showFlag == 'listCon'">
      <div class="backBtn" type="primary" @click="back">返回</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    return {
      testCode: "",
      form: {},
      showFlag: "listCon",
      mainConData: [
        {
          title: "基本信息",
          icon: require("@/assets/images/mobile/info.png"),
          url: "/baseInfo",
        },
        {
          title: "我的二维码",
          icon: require("@/assets/images/mobile/my_srcode.png"),
          url: "/myQrCode",
        },
        {
          title: "手机绑定",
          icon: require("@/assets/images/mobile/phone_bind.png"),
          url: "phone_bind",
        },
        {
          title: "关于我们",
          icon: require("@/assets/images/mobile/aboutus.png"),
          url: "/aboutus",
        },
      ],
      listConData: [
        {
          title: "政策咨询",
          num: 0,
          icon: require("@/assets/images/mobile/cosult.png"),
        },
        {
          title: "解决问题",
          num: 0,
          icon: require("@/assets/images/mobile/question.png"),
        },
        {
          title: "需求服务",
          num: 0,
          icon: require("@/assets/images/mobile/xytb.png"),
        },
        {
          title: "意见建议",
          num: 0,
          icon: require("@/assets/images/mobile/suggestion.png"),
        },
        {
          title: "举报投诉",
          num: 0,
          icon: require("@/assets/images/mobile/client_ts.png"),
        },
        {
          title: "部门评价",
          num: 0,
          icon: require("@/assets/images/mobile/bmpj.png"),
        },
      ],
      rules: {
        oldPhone: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: "blur",
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
          },
        ],
        newPhone: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: "blur",
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
          },
        ],
      },
      hastime: 0,
      hasFlag: false,
      hastimeinter: null,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
  },
  created() {
    this.getnum();
  },
  watch: {
    listConData: {
      deep: true,
      handler: function (newVal) {
        return newVal;
      },
    },
  },
  mounted() {},
  methods: {
    clearParam() {
      this.form.oldPhone = "";
      this.form.newPhone = "";
      this.form.verifyCode = "";
    },
    closePhoneBindPage() {
      this.showFlag = "listCon";
      this.clearParam();
    },
    tonewpage(index) {
      this.$router.push({
        path: "/infoList",
        query: {
          type: index,
        },
      });
    },
    toRelevantPage(param) {
      let url = param;
      switch (url) {
        case "phone_bind":
          this.showFlag = "phoneBind";
          break;
        default:
          this.$router.push(url);
          break;
      }
    },
    back() {
      this.$router.push("/suqiuMobile");
    },
    tosetInterval() {
      let time = 60;
      this.hastimeinter = setInterval(() => {
        if (time > 0) {
          this.hastime = time;
          this.hasFlag = true;
        } else {
          this.hastime = 0;
          this.hasFlag = false;
          clearInterval(this.hastimeinter);
        }
        time--;
      }, 1000);
    },
    getVerCode() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "正在获取验证码",
            spinner: "el-icon-loading",
          });
          let url = "/dev-api/appinfo/querySmsCode";
          let params = {
            phone: this.form.oldPhone, //原手机号
            phonenumber: this.form.newPhone, //新手机号
            shxydm: this.userInfo.tyshxydm, //验证码
          };
          this.$httpApi
            .post(url, params)
            .then((res) => {
              this.$nextTick(() => {
                loading.close();
              });
              if (res.code == 200) {
                this.$message.success("验证码已发送");
                this.testCode = res.msg;
                this.tosetInterval();
              } else {
                this.$message.error(`错误：${res.msg}`);
              }
            })
            .catch((err) => {
              console.log("Err:", err);
              this.$message("网络异常，请稍后重试");
              this.$nextTick(() => {
                loading.close();
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit() {
      this.testCode;
      let url = "/dev-api/appinfo/updateQyPhone";
      let param = {
        phone: this.form.oldPhone, //原手机号
        phonenumber: this.form.newPhone, //新手机号
        shxydm: this.userInfo.tyshxydm, //验证码
        verCode: this.form.verifyCode, //手机验证码
      };
      this.$httpApi
        .post(url, param)
        .then((res) => {
          this.$message.success(res.msg);
          this.clearParam();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getnum() {
      let url = "/dev-api/sq_info/countAllNumByTyshxydm";
      let params = {
        tyshxydm: this.userInfo.tyshxydm,
      };
      this.$httpApi
        .get(url, params)
        .then((r) => {
          if (r.code == 200) {
            this.listConData[0].num = r.data.zczx.num;
            this.listConData[1].num = r.data.jjwt.num;
            this.listConData[2].num = r.data.xqfw.num;
            this.listConData[3].num = r.data.yjjy.num;
            this.listConData[4].num = r.data.jbtx.num;
            this.listConData[5].num = r.data.bmpj.num;
          }
        })
        .catch((e) => {});
    },
  },
  beforeDestroy() {
    clearInterval(this.hastimeinter);
    // clearInterval(this.msgCodeInfo.timer);
  },
};
</script>
<style lang='scss' scoped>
.header {
  width: 100%;
  height: 9.5rem;
  font-size: 1.125rem;
  background: #36ab60;
  position: relative;
  .backImg {
    width: 30px;
    position: absolute;
    top: 10px;
    left: 10px;
  }
  .headCon {
    width: 100%;
    height: 7.5rem;
    .imgCon {
      width: 5.625rem;
      height: 5.625rem;
      background: #fff;
      border-radius: 50%;
      margin: 0 20px;
    }
  }
}
.content {
  .mainCon {
    width: 100%;
    height: 120px;
    margin-bottom: 30px;
    .mainConItem {
      width: 22.5%;
      height: 80%;
      img {
        width: 2rem;
      }
      p {
        width: 100%;
        text-align: center;
        font-size: 1rem;
        color: #8a8f8a;
        margin-top: 5px;
      }
    }
  }
  .listCon {
    width: 100%;
    min-height: 24rem;
    padding: 0 10px;
    .listConItem {
      margin: 30px 0;
      position: relative;
      img {
        width: 2rem;
      }
      p {
        color: #000;
        font-size: 1.125rem;
        margin-left: 16px;
      }
      .num {
        width: 1.25rem;
        height: 1.25rem;
        text-align: center;
        line-height: 1.25rem;
        border-radius: 50%;
        position: absolute;
        top: 0px;
        left: 7.8125rem;
        font-size: 0.875rem;
        background: #fa735b;
        color: #fff;
      }
      .arrow {
        position: absolute;
        top: 0px;
        right: 0.625rem;
      }
    }
  }
  .phoneBind {
    width: 90%;
    height: 21.25rem;
    border: 2px solid #e2e2e2;
    border-radius: 20px;
    margin: 0 auto;
    margin-top: -20px;
    position: relative;
    .closePhoneBind {
      width: 30px;
      position: absolute;
      top: 10px;
      right: 19px;
    }
    p {
      font-size: 1.375rem;
      color: #36ab60;
      font-weight: 600;
      text-align: center;
      margin: 20px auto;
    }
    .formCon {
      width: 100%;
      padding: 10px 20px;
      font-size: 1rem !important;
      .mailCode {
        width: 50%;
        background-color: #1292ff;
        color: white;
      }
    }
  }
}
.backBtnCon {
  width: 100%;
  height: 3.125rem;
  .backBtn {
    width: 12.5rem;
    height: 2.5rem;
    font-size: 1rem;
    border-radius: 1.25rem;
    background: #11a9cc;
    text-align: center;
    line-height: 2.5rem;
    color: #fff;
    margin: 0 auto;
  }
}
</style>
